import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./AddNewKYC.module.css";
const AddNewKYC = ({ isVisible, onClose, check, className = "", modalRef }) => {
  // const [check,setCheck]=useState(true)
  const navigate = useNavigate();
  const { id } = useParams();

  if (!isVisible) {
    return null;
  }
  return (
    <div className={styles.modlestyle}>
      <div ref={modalRef} className={[styles.xCircleParent, className].join(" ")}>
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <span style={{ fontWeight: "500", fontSize: "18px" }}>Choose KYC type</span>
          <img
            className={styles.xCircleIcon}
            alt=""
            src="/xcircle.svg"
            onClick={() => {
              onClose();
            }}
          />
        </div>

        <div className={styles.frameParent}>
          <div
            className={styles.building07Parent}
            onClick={() => {
              navigate(`/content/company/newcompanykyc`);
            }}
          >
            <img className={styles.building07Icon} alt="" src="/building07.svg" />
            <b className={styles.company}>Company</b>
          </div>
          <div
            className={`${styles.vectorParent}`}
            onClick={() => {
              navigate(`/content/company/director`);
            }}
          >
            <img className={styles.vectorIcon} alt="" src="/Vector.svg" />
            <b className={styles.company}>Authorized Signatory</b>
          </div>
        </div>
      </div>
    </div>
  );
};

AddNewKYC.propTypes = {
  className: PropTypes.string,
};

export default AddNewKYC;
